import { RestaurantCatalog } from "./RestaurantCatalog";

export default RestaurantCatalog;
